import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import "bootstrap/dist/css//bootstrap.min.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-multi-carousel/lib/styles.css";
import "./Assets/css/custom.css";
import "./Assets/css/style.css";

import store from "./Redux/Store";
const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Suspense>
      <Router>
        <App />
      </Router>
    </Suspense>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
